import { createSlice } from '@reduxjs/toolkit'
import newsItem from "./newsItem";

export const homepageSlice = createSlice({
  name: 'homepage',
  initialState: {
    loading: false,
    newsIds: [],
    newsItems: {},
  },
  reducers: {
    loading: (state) => {
      state.loading = true;
    },
    error: (state) => {
      state.loading = false;
    },
    success: (state, action) => {
      state.loading = false;
      const newItems = action.payload.items.map(newsItem);
      const newIds = newItems.map(item => item.id);
      // TODO: Actually load subsequent pages of news items
      state.newsIds.push(...newIds);
      newItems.forEach(item => {
        state.newsItems[item.id] = item;
      });
    }
  }
});

export const actions = homepageSlice.actions;

export default homepageSlice.reducer;